import React, { ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Responsive, ResponsiveProps } from 'react-grid-layout';
import sizeMe from 'react-sizeme';
import { colors } from '@dexma/ui-components';

const sizeMeHOC = sizeMe({
    monitorWidth: true,
    refreshRate: 800,
});

const ResponsiveReactGridLayout = (props: ResponsiveProps & { containerWidth: number }): ReactElement => {
    const { containerWidth, ...passProps } = props;
    const [animated, setAnimated] = useState(false);
    useEffect(() => {
        setAnimated(true);
    }, []);

    return (
        <StyledResponsiveReactGridLayout
            className={animated ? 'animated' : 'none'}
            width={containerWidth}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...passProps}
        />
    );
};

const StyledResponsiveReactGridLayout = styled(Responsive)`
    .react-grid-item.cssTransforms {
        transition-property: none;
    }
    .animated .react-grid-item.cssTransforms {
        transition-property: transform;
    }
    position: relative;

    // Drag placeholder
    .react-grid-item.react-grid-placeholder {
        background-color: ${colors.gray500};
        border-radius: 8px;
    }

    // Drag arrow
    .react-grid-item > .react-resizable-handle::after {
        right: 10px;
        bottom: 10px;
        width: 10px;
        height: 10px;
        border-right: 2px solid ${colors.gray500};
        border-bottom: 2px solid ${colors.gray500};
        z-index: 100000;
    }
`;

export default sizeMeHOC(ResponsiveReactGridLayout);
